import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { AdviserComponent }  from './adviser.component';
import { AdvisersComponent } from './advisers.component';
import { AdvisersService }   from './advisers.service';
import { AdvisersStates }    from './advisers.states';
import { SharedModule }      from '../shared/shared.module';
import { TableModule }       from '../table/table.module';

@NgModule({
  declarations: [
    AdviserComponent,
    AdvisersComponent
  ],
  entryComponents: [
    AdviserComponent,
    AdvisersComponent
  ],
  imports: [
    SharedModule,
    TableModule,

    UIRouterModule.forChild({ states: AdvisersStates })
  ],
  providers: [
    AdvisersService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class AdvisersModule {}
